import { useSyncExternalStore } from 'react';

import { createSessionStore } from '@spotify/confidence-flag-evaluation-react';

const COLLAPSED_FLAGS_KEY = 'devbar-flag-highlight-collapsed';

const collapsedStore = createSessionStore<readonly string[]>({
  key: COLLAPSED_FLAGS_KEY,
  empty: [],
  parse: raw => raw.split(',').filter(Boolean),
  serialize: flags => [...flags].sort().join(','),
});

export const useCollapsedFlagHighlights = (): readonly string[] =>
  useSyncExternalStore(
    collapsedStore.subscribe,
    collapsedStore.getSnapshot,
    collapsedStore.getServerSnapshot,
  );

export const setFlagHighlightCollapsed = (
  flag: string,
  collapsed: boolean,
): void => {
  const current = collapsedStore.read();
  if (current.includes(flag) === collapsed) {
    return;
  }
  collapsedStore.write(
    collapsed ? [...current, flag] : current.filter(name => name !== flag),
  );
};

export const expandAllFlagHighlights = (): void => collapsedStore.clear();
